import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SiteLayout from "../components/feature/SiteLayout";
import FilmCategory from "../pages/category/FilmCategory";
import ActorCategory from "../pages/category/ActorCategory";
import FilmDetail from "../pages/detail/FilmDetail";
import ActorDetail from "../pages/detail/ActorDetail";
import Search from "../pages/search/Search";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/actor", element: <ActorCategory /> },
      { path: "category/:type", element: <FilmCategory /> },
      { path: "detail/film/:id", element: <FilmDetail /> },
      { path: "detail/actor/:id", element: <ActorDetail /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;